// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onSmallerTextSize{font-size:17px!important}@media screen and (min-width:1000px){.changeDateBoxLoc{margin-bottom:-20%;margin-top:-10%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
